var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1"},[_vm._v("Selecciona una conversa")])}
var staticRenderFns = []

export { render, staticRenderFns }